var _module_exports = "<span\n  ng-repeat=\"item in $ctrl.options.numberOflines\"\n  ng-style=\"{ 'height': $ctrl.options.height, 'width': $ctrl.options.width}\">\n</span>\n";;
var path = '/workspace/src/app/common/ui/skeleton/skeleton.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;